/* eslint-disable react/function-component-definition */
import React from "react";
import BuyBox from "@/bit/components/components.buy-box";

export default function BuyBoxContainer({
  orionModuleInfo,
  simplePhone,
  productName,
  alias,
  loading,
}) {
  return (
    <div>
      <BuyBox
        {...orionModuleInfo}
        simplePhone={simplePhone}
        productName={productName}
        alias={alias}
        skeletonClassName={loading ? "skeleton" : ""}
      />
    </div>
  );
}
